import './slider.scss';
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

(function() {
  const swiper = new Swiper('.swiper', {
    autoplay: {
      delay: 3000,
    },
    freeMode: true,
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 15,
    breakpoints: {
      1000: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  });
})();